import { render, staticRenderFns } from "./step-1.vue?vue&type=template&id=8187ae34&scoped=true&"
import script from "./step-1.vue?vue&type=script&lang=js&"
export * from "./step-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8187ae34",
  null
  
)

export default component.exports